
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.995.004C38.428-.167 27.52 4.833 20.616 12.59a25.907 25.907 0 00-17.754 7.56 1.023 1.023 0 00.572 1.737l7.868 1.127-.971 1.089a1.02 1.02 0 00.04 1.402l13.122 13.122c.198.198.46.298.723.298.243 0 .485-.086.68-.26l1.088-.971 1.127 7.868c.055.384.357.666.722.788.094.03.192.045.292.045.29 0 .586-.126.79-.328 4.666-4.666 7.37-11.09 7.495-17.69 7.765-6.918 12.805-17.823 12.583-27.375a1.025 1.025 0 00-.998-.997zm-9.408 17.624a5.088 5.088 0 01-3.61 1.492 5.088 5.088 0 01-3.61-1.492 5.114 5.114 0 010-7.22 5.11 5.11 0 017.22 0 5.11 5.11 0 010 7.22zM5.562 34.512C3.377 36.696.378 46.566.043 47.682a1.024 1.024 0 00.978 1.315c.098 0 .196-.014.294-.043 1.117-.334 10.986-3.334 13.17-5.518a6.318 6.318 0 000-8.924 6.32 6.32 0 00-8.923 0z","fill":"#0183FE"}})])
          )
        }
      }
    